import { Checkbox, DatePicker, Form, Input, Select, Skeleton, Spin } from "antd";
import dayjs from "dayjs";
import axiosInstance, { api } from "../common/api";
import { requiredField } from "../common/common";
import DebounceSelect from "../common/DebounceSelect";
import SimpleFormPage from "../common/SimpleFormPage";
import { useParams, useSearchParams } from "react-router";
import { useEffect, useState } from "react";

const DynamicFormItem = ({ formItem }) => {
  const types = {
    EMPLOYEE: (
      <DebounceSelect
        minSize={1}
        labelInValue={false}
        fetchOptions={(query) =>
          api.employee
            .list({ query, pageSize: 9999 })
            .then(({ data }) => data.map((x) => ({ label: x.fullName, value: x.id })))
        }
      />
    ),
    VEHICLE: (
      <DebounceSelect
        minSize={1}
        labelInValue={false}
        fetchOptions={(query) =>
          api.vehicle
            .list({ query, pageSize: 9999 })
            .then(({ data }) => data.map((x) => ({ label: x.licensePlate, value: x.id })))
        }
      />
    ),
    STRING: <Input />,
    BOOLEAN: <Checkbox />,
  };

  return (
    <Form.Item
      name={["model", "params", formItem.name]}
      rules={[requiredField]}
      label={formItem.label}
    >
      {types[formItem.type]}
    </Form.Item>
  );
};

const SectionsItem = ({ sections }) => {
  return (
    <Form.Item name={["model", "sections"]} label="Sezioni">
      <Select mode="multiple" options={sections.map((x) => ({ value: x }))} showSearch />
    </Form.Item>
  );
};

export default function () {
  const { id } = useParams();
  const [sp, setSP] = useSearchParams();
  const loadFromRequest = sp.get("loadFromRequest") ?? false;
  const [loading, setLoading] = useState(false);
  const [posRequest, setPosRequest] = useState({});
  const [form] = Form.useForm();
  const posModelWatch = Form.useWatch("posModel", form);
  const posModel = posModelWatch && JSON.parse(posModelWatch);
  console.log(posModel);

  useEffect(() => {}, []);

  const loadFn = (form) => {
    setLoading(true);
    api.posRequest
      .list({ workSite: Number(id), pageSize: 1 })
      .then((data) => {
        const pr = data.data?.[0];
        setPosRequest(pr ?? {});
        if (pr && ["SUBMITTED", "IN_PROGRESS"].includes(pr.status))
          form.setFieldsValue({
            ...pr,
            employees: pr.employees.map((e) => ({ label: e.fullName, value: e.id })),
            vehicles: pr.vehicles.map((v) => ({ label: v.description, value: v.id })),
          });
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (posRequest && posRequest.status === "SUBMITTED") {
      setLoading(true);
      api.posRequest.claimRequest(posRequest.id).finally(() => setLoading(false));
    }
  }, [posRequest]);

  return (
    <Spin spinning={loading}>
      <SimpleFormPage
        loadFn={loadFn}
        title="Nuovo POS"
        form={form}
        transformData={(form) => ({
          ...form,
          workSite: Number(id),
          isVerified: form.isVerified ?? false,
          employees: form.employees.map((e) => e.value),
          vehicles: (form.vehicles ?? []).map((v) => v.value),
          posModel: form.posModel && JSON.parse(form.posModel).id,
        })}
      >
        <Form.Item label="Dipendenti" rules={[requiredField]} name="employees">
          <DebounceSelect
            mode="multiple"
            minSize={1}
            fetchOptions={(query) =>
              axiosInstance
                .get("employee", { params: { query, pageSize: 9999 } })
                .then(({ data }) => data.data.map((x) => ({ label: x.fullName, value: x.id })))
            }
          />
        </Form.Item>
        <Form.Item label="Veicoli" name="vehicles">
          <DebounceSelect
            mode="multiple"
            minSize={1}
            fetchOptions={(plate) =>
              api.vehicle
                .list({ plate, pageSize: 9999 })
                .then((data) =>
                  data.data.map((x) => ({ label: `${x.plate} • ${x.description}`, value: x.id })),
                )
            }
          />
        </Form.Item>

        <Form.Item label="Modello POS" rules={[requiredField]} name="posModel">
          <DebounceSelect
            labelInValue={false}
            minSize={1}
            fetchOptions={(query) =>
              api.posModel
                .list({ query, pageSize: 9999 })
                .then(({ data }) => data.map((x) => ({ label: x.name, value: JSON.stringify(x) })))
            }
          />
        </Form.Item>
        {posModel &&
          posModel.formItems.map((item, index) => <DynamicFormItem key={index} formItem={item} />)}
        {posModel && <SectionsItem sections={posModel.sections} />}
        <Form.Item name="isVerified" valuePropName="checked" initialValue={false}>
          <Checkbox>POS verificato dal cliente/committente</Checkbox>
        </Form.Item>

        <Form.Item
          label="Data di emissione"
          name="issueDate"
          rules={[requiredField]}
          getValueProps={(value) => ({ value: value && dayjs(value) })}
          normalize={(value) => value && value.format("YYYY-MM-DD")}
        >
          <DatePicker format="DD-MM-YYYY" />
        </Form.Item>
      </SimpleFormPage>
    </Spin>
  );
}
